export const DIAG_URL = "/diagnostico";
export const WPP_URL = "https://wa.me/5547992536961";
export const EMAIL_URL = "mailto:atendimento@fuchsbrand.com.br";
export const INSTA_URL = "https://www.instagram.com/fuchs.brand_/";
export const LINKEDIN_URL = "https://www.linkedin.com/in/danyfuchs4D";
export const SITE_URL = "https://fuchsbrand.com.br/";

export const NAV_LINKS = [
  { to: "/", label: "Início", testid: "nav-link-home" },
  { to: "/quem-somos", label: "Quem Somos", testid: "nav-link-quem-somos" },
  { to: "/metodo-4d", label: "Método 4D", testid: "nav-link-metodo-4d" },
  { to: "/conteudo", label: "Conteúdo", testid: "nav-link-conteudo" },
  { to: "/contato", label: "Contato", testid: "nav-link-contato" },
];
